module.exports = __webpack_public_path__ + "static/boat-poster-8888de146ee56978b0a7eebbc86e6b93.jpg";